<template>
    <overlay class="wechat-overlay" v-show="isShown">
        <section class="wechat">
            <img class="wechat-qr-code" src="~@/assets/images/overlays/wechat-qr-code.png">
            <p>扫一扫<br>关注如意官方微信</p>
        </section>
    </overlay>
</template>

<script>
  import { mapState } from 'vuex'

  import Overlay from './Overlay'

  export default {
    computed: {
      ...mapState({
        isShown: (state) => state.overlays.wechat.isShown
      })
    },
    components: {
      Overlay
    }
  }
</script>

<style lang="scss">
    @import '~@/assets/styles/app';

    .wechat-overlay {
        background-color: $white;
        background-image: url("~@/assets/images/overlays/wechat-bg-xs.jpg");
        background-position: top center;
        background-repeat: no-repeat;
        background-size: cover;

        @include media-breakpoint-up(md) {
            background-image: url("~@/assets/images/overlays/wechat-bg-md.jpg");
        }

        @include media-breakpoint-up(xl) {
            background-image: url("~@/assets/images/overlays/wechat-bg-xl.jpg");
        }
    }

    .wechat {
        align-items: center;
        color: $white;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: center;
        text-align: center;

        &-qr-code {
            display: block;
            margin-bottom: 1rem;
        }
    }
</style>


// WEBPACK FOOTER //
// WechatOverlay.vue?069ce3ab